module.exports = fox._r("images/stateoff/site-under-construction-bg.jpg", __webpack_public_path__ + "_/_/_/root/images/stateoff/site-under-construction-bg.jpg");


//////////////////
// WEBPACK FOOTER
// /var/www/jenkins.devel.ac/workspace/MC_Frontend_Rollout/site/root/images/stateoff/site-under-construction-bg.jpg
// module id = 204
// module chunks = 4